import React from 'react'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import { IconTrash } from '@tabler/icons-react'

interface Iprops {
  email: string
  emails: string[]
  setEmails: (value: string[]) => void
}

const EditLeadEmailRow: React.FC<Iprops> = ({ email, emails, setEmails }) => {
  const theme = useTheme()

  const removeItem = () => {
    const newEmails = emails.filter((i: string) => i !== email)
    setEmails(newEmails)
  }

  return (
    <div className="EditEmailRow">
      <div className="row">
        <div className="email">{email}</div>
        <div className="options">
          <div style={{ borderRight: 'none' }} />
          <div style={{ borderRight: 'none' }} />
          <div style={{ borderRight: 'none' }} />
          <Tooltip className="remove" title="Remove" onClick={removeItem}>
            <IconButton>
              <IconTrash stroke="none" color={theme.palette.error.dark} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default EditLeadEmailRow
